import { render, staticRenderFns } from "./Erro.vue?vue&type=template&id=03ab4cbc&scoped=true"
import script from "./Erro.vue?vue&type=script&lang=js"
export * from "./Erro.vue?vue&type=script&lang=js"
import style0 from "./Erro.vue?vue&type=style&index=0&id=03ab4cbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ab4cbc",
  null
  
)

export default component.exports